module.exports = __webpack_public_path__ + "media/application/images/2018/my-consumer-add-plus-85895203d0ff9eb9fbba691412f54ff2.svg";